const SaveIcon = ({
  className = "w-3 h-3",
  fill = "currentColor",
  onClick,
  ...props
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.0576 14.95H3.27431C2.04654 14.95 1.05487 13.9 1.05487 12.6V3.35C1.05487 2.05 2.04654 1 3.27431 1H10.1688C10.7354 1 11.3021 1.25 11.7271 1.7L13.616 3.7C14.041 4.15 14.2771 4.75 14.2771 5.35V12.65C14.2771 13.9 13.2854 14.95 12.0576 14.95ZM3.27431 2C2.56598 2 1.99931 2.6 1.99931 3.35V12.65C1.99931 13.4 2.56598 14 3.27431 14H12.0576C12.766 14 13.3326 13.4 13.3326 12.65V5.3C13.3326 4.95 13.191 4.6 12.9549 4.35L11.066 2.35C10.8299 2.1 10.4993 2 10.1688 2H3.27431Z"
        fill={fill}
      />
      <path
        d="M9.93265 5.65H3.79376C3.4632 5.65 3.17987 5.35 3.17987 5V3.85C3.17987 3.5 3.41598 3.25 3.74654 3.25H9.88543C10.216 3.25 10.4993 3.5 10.4993 3.85V5C10.4993 5.35 10.216 5.65 9.93265 5.65Z"
        fill={fill}
      />
      <path
        d="M7.66598 11.85C6.34376 11.85 5.25764 10.7 5.25764 9.3C5.25764 7.9 6.34376 6.75 7.66598 6.75C8.9882 6.75 10.0743 7.9 10.0743 9.3C10.0743 10.7 8.9882 11.85 7.66598 11.85ZM7.66598 7.7C6.8632 7.7 6.20209 8.4 6.20209 9.25C6.20209 10.1 6.8632 10.8 7.66598 10.8C8.46876 10.8 9.12987 10.1 9.12987 9.25C9.12987 8.4 8.46876 7.7 7.66598 7.7Z"
        fill={fill}
      />
    </svg>
  );
};
export default SaveIcon;
